import { atom } from "recoil";

export const panelPaymentsUsersStore = atom({
	key: "panelPaymentsUsersStore",
	default: {
		show: false,
		loaded: false,
		statusLoaded: true,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		data: [],
		sorting: {
			sortingColumn: {
				sortingField: "",
			},
			sortingDescending: false,
		},
		search: {

		},
		pagination: {
			current: 0,
			total: 0,
			page: 0,
			perPage: 0,
			totalPage: 0,
		},
	},
});
